import { avatarTint, initialsOf } from '../../lib/format';
import { parseSafeUrl } from '../../lib/safe-url';

/**
 * Assignee avatar. The URL comes from GitLab via our API, but it is still a URL from outside, so it
 * goes through the same allow-list as every other link and falls back to initials when it fails.
 */
export function Avatar({
  name,
  url,
  size = 24,
  title,
}: {
  name: string | null | undefined;
  url?: string | null;
  size?: number;
  title?: string;
}) {
  const label = title ?? name ?? 'Unassigned';
  const safe = url ? parseSafeUrl(url) : { ok: false as const, reason: 'no avatar' };
  const dimension = { width: size, height: size };

  if (!name) {
    return (
      <span
        title="Unassigned"
        aria-label="Unassigned"
        style={dimension}
        className="inline-flex shrink-0 items-center justify-center rounded-full border border-dashed border-[color:var(--color-ink-subtle)] text-[10px] text-[color:var(--color-ink-subtle)]"
      >
        —
      </span>
    );
  }

  if (safe.ok) {
    return (
      <img
        src={safe.href}
        alt={label}
        title={label}
        style={dimension}
        loading="lazy"
        decoding="async"
        referrerPolicy="no-referrer"
        className="shrink-0 rounded-full object-cover"
      />
    );
  }

  return (
    <span
      title={label}
      aria-label={label}
      style={{ ...dimension, backgroundColor: avatarTint(name) }}
      className="inline-flex shrink-0 items-center justify-center rounded-full text-[10px] font-bold tracking-wide text-white"
    >
      {initialsOf(name)}
    </span>
  );
}
